var _rect, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 18,
  height: 18,
  rx: 2,
  ry: 2
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  x2: 16,
  y1: 2,
  y2: 6
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  x2: 8,
  y1: 2,
  y2: 6
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  x2: 21,
  y1: 10,
  y2: 10
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  x2: 14,
  y1: 14,
  y2: 18
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  x2: 14,
  y1: 18,
  y2: 14
})));
export { SvgCalendarX as ReactComponent };
export default __webpack_public_path__ + "static/media/CalendarX.d33b45fdfd8cfc7865391545695bee1f.svg";